import { kcFetch, API_BASE, authHeaders } from "../../lib/apiClient";

// ============================================================
// /admin/* API helpers — Users & Roles management.
// Extracted verbatim from KingdomConnect.jsx; no behaviour changes.
// ============================================================
export async function apiAdminCreateUser(payload) {
  const res = await kcFetch(`${API_BASE}/admin/users`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeaders() },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: "Create failed" }));
    throw new Error(typeof err.detail === "string" ? err.detail : "Create failed");
  }
  return res.json();
}

export async function apiAdminUpdateUser(userId, payload) {
  const res = await kcFetch(`${API_BASE}/admin/users/${userId}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeaders() },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: "Update failed" }));
    throw new Error(typeof err.detail === "string" ? err.detail : "Update failed");
  }
  return res.json();
}

export async function apiAdminDeleteUser(userId) {
  const res = await kcFetch(`${API_BASE}/admin/users/${userId}`, {
    method: "DELETE",
    headers: { ...authHeaders() },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: "Delete failed" }));
    throw new Error(typeof err.detail === "string" ? err.detail : "Delete failed");
  }
  return res.json();
}
